import {
    Box,
    Button,
    Divider,
    Modal,
    Typography,
} from "@mui/material";

const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 420,
    bgcolor: "background.paper",
    borderRadius: "16px",
    boxShadow: 24,
    p: 3,
};
const GRADIENT = "linear-gradient(135deg, rgb(255, 113, 61) 0%, rgb(245, 159, 10) 100%)";
const ProviderSuccessModal = ({ open, onContinue }) => {
    return (
        <Modal open={open} onClose={() => { }}>
            <Box sx={modalStyle}>
                <Typography variant="h6" fontWeight={600} sx={{ textTransform: 'capitalize', fontSize: '23px' }}>
                    Payment & Registration Successful
                </Typography>
                <Typography><i>You’re now ready to set up your course.</i></Typography>

                <Divider sx={{ my: 1.5 }} />

                <Box sx={{ mt: 2 }}>
                    <Typography sx={{ mb: 1 }}>
                        &bull; Login credentials have been sent to your registered email address.
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        &bull; Click <strong>Continue</strong> to launch the course creation wizard.
                    </Typography>
                </Box>

                <Button
                    fullWidth
                    variant="contained"
                    onClick={onContinue}
                    sx={{
                        mt: 2,
                        py: 1.5,
                        fontSize: '1rem',
                        fontWeight: "600",
                        textTransform: 'none',
                        borderRadius: '0.75rem',
                        background: GRADIENT,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                        transition: "all 0.3s ease",
                        "& .arrow": {
                            transition: "transform 0.3s ease",
                        },
                        "&:hover .arrow": {
                            transform: "translateX(6px)",
                        },
                    }}
                >
                    Continue
                </Button>
            </Box>
        </Modal>
    );
};

export default ProviderSuccessModal;
